export const styles = {
  chip: (background, color) => {
    return {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '0px 8px',
      borderRadius: '20px',
      color,
      background,
    };
  },
  text: (color) => {
    return {
      maxWidth: '100px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      fontSize: '12px',
      fontWeight: 400,
      color,
    };
  },
};
